<div>
  @switch (consentPurpose.id_component) {
    @case (specificConsentsCheckboxComponentEnum.LEGAL_CONSENT) {
      <span
        [innerHTML]="
          legalConsentText | translate: { marsPrivacyURL: openTermsHref() }
        "
      ></span>
    }
    @case (specificConsentsCheckboxComponentEnum.KR_PRIVACY_COLLECT) {
      <rc-accordion
        [items]="[{ label: 'tickbox_korea-tickbox1-title-1' | translate }]"
        [labelButtonClose]="'action-hide_content' | translate"
        [mode]="RCAccordionMode.SUFFIX"
      >
        <ng-template>
          <app-detail-terms-kr-privacy-collect></app-detail-terms-kr-privacy-collect>
        </ng-template>
      </rc-accordion>
    }
    @case (specificConsentsCheckboxComponentEnum.KR_PRIVACY_TRANSFER) {
      <rc-accordion
        [items]="[{ label: 'tickbox_korea-tickbox2-title-1' | translate }]"
        [labelButtonClose]="'action-hide_content' | translate"
        [labelButtonOpen]="'action-see_content' | translate"
        [mode]="RCAccordionMode.SUFFIX"
      >
        <ng-template>
          <app-detail-terms-kr-privacy-transfer></app-detail-terms-kr-privacy-transfer>
        </ng-template>
      </rc-accordion>
    }
    @default {
      @if (consentPurpose.text) {
        <span
          [innerHTML]="consentPurpose.text | translate | markdownLink"
        ></span>
      }
      @if (consentPurpose.consentRequired) {
        <span class="required tail-margin" aria-hidden="true">*</span>
        <span class="visible-hidden">{{
          'registerApp_consent_required' | translate
        }}</span>
      }
    }
  }
</div>
